import * as React from 'react';
import { Button, Col, Form, FormFeedback, FormGroup, Input, Row } from 'reactstrap';
import { ProjectTypeList } from 'src/components/shared/Input/ProjectTypeList';
import { IGlobalContextProps, withGlobalContext } from 'src/context/global.context';
import { IProject } from 'src/model';
import { deleteUser } from 'src/services';


interface IProjectModalProps {
  invalidProjectType: boolean;
  project: IProject;
  changeStep: (stepNumber: number) => void;
  handleChange: (e: React.ChangeEvent<Element>) => void;
  handleClick: (id: string) => void;
  toggleCreateProjectModal: () => void;
}

const CreateProjectSecondStep: React.SFC<
  IProjectModalProps & IGlobalContextProps
> = ({
  changeStep,
  context,
  project,
  handleChange,
  handleClick,
  invalidProjectType,
  toggleCreateProjectModal,
}) => {
  const [state, setState] = React.useState({
    invalid: false,
  });
  const isValid = project.title && project.description;

  const handleProject = async () => {
    if (isValid) {
      changeStep(3);
    } else {
      setState({ invalid: true });
    }
  };

  const toggleModalWithDeleteUser = () => {
    if (context.isCreating) {
      deleteUser();
      context.updateUser(true);
      context.toggleIsCreating();
      changeStep(1);
    }
    toggleCreateProjectModal();
  };

  return (
    <Form className='p-5'>
      <FormGroup>
        <Input
          type='text'
          name='title'
          placeholder='Titre du projet*'
          invalid={state.invalid && !!!project.title}
          value={project.title}
          onChange={handleChange}
        />
        <FormFeedback>Vous devez renseigner le titre du project</FormFeedback>
      </FormGroup>
      <FormGroup className='d-flex row mt-3'>
        <Col xs='2' className='mx-0'>
          <span>Type de projet*</span>
        </Col>
        <Col xs='10' className='pl-0'>
          <ProjectTypeList
            edit={true}
            projectType={project.projectType}
            handleClick={handleClick}
          />
          <Input invalid={invalidProjectType} style={{ display: 'none' }} />
          <FormFeedback>
            Vous ne pouvez sélectionner que 3 domaines d'intervention
          </FormFeedback>
        </Col>
      </FormGroup>
      <FormGroup>
        <Input
          className='mt-3'
          type='textarea'
          name='description'
          placeholder='Description du project*'
          invalid={state.invalid && !!!project.description}
          value={project.description}
          onChange={handleChange}
        />
        <FormFeedback>
          Vous devez renseigner une description de votre project
        </FormFeedback>
      </FormGroup>
      <FormGroup>
        <span className='d-block font-weight-bolder mb-3'>
          Champs obligatoires *
        </span>
      </FormGroup>
      <Row className='d-flex justify-content-end'>
        <Col xs='6'>
          <Button
            className='text-uppercase text-white bg-dark border-0 mt-3'
            onClick={toggleModalWithDeleteUser}
          >
            Annuler
          </Button>
        </Col>
        <Col xs='6'>
          <Button
            className='text-uppercase text-white bg-success float-right border-0 mt-3'
            onClick={handleProject}
          >
            Étape 3 >
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export const CreateProjectSecondStepWithGlobalContext = withGlobalContext(
  CreateProjectSecondStep
);



// WEBPACK FOOTER //
// ./src/components/shared/Modals/CreateProjectModal/CreateProjectSecondStep.tsx